/**
 * @module ServiceTestsFormControlConstants
 * @description React-hook-form control flags extracted from ServiceTestsConstants.
 * Separates RHF machinery from business-domain constants.
 */
export const SHOULD_DIRTY_TRUE = { shouldDirty: true };
export const SHOULD_DIRTY_FALSE = { shouldDirty: false };
